import { toast } from 'react-toastify';
import config from '../config';
import selectedEnvironment from '../env';
import AuthService from './auth.service';
const API_BASE = config[selectedEnvironment].API_URL;
const API_URL = `${API_BASE}/Reports`;
const REPORTS_API = `${API_BASE}/ReportedTaxes`; // or /api/ReportedTaxes
const CLIENTS_API = `${API_BASE}/Clients`;
const AccountCards_API_URL = `${API_BASE}/AccountCards`;

const getCurrentToken = async () => {
    const token =  localStorage.getItem('token');
    return token ? JSON.parse(token) : null;
};

const getReferenceSequenceReport = async (caseId, startDate, endDate, accountCardId = null, sortCodeId = null, token) => {
    const response = await fetch(`${API_URL}/ReferenceSequenceReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate,
            AccountCardCode: accountCardId,
            SortCodeId: sortCodeId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    const blob = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(blob);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `ReferenceSequenceReport-${caseId}.pdf`); // Use a suitable filename
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the object URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
};

const getReferenceSequenceReportHtml = async (caseId, startDate, endDate, accountCardId = null, sortCodeId = null, token) => {
    const response = await fetch(`${API_URL}/ReferenceSequenceReportHtml`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate,
            AccountCardCode: accountCardId,
            SortCodeId: sortCodeId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    const htmlContent = await response.text();
    return htmlContent;
};

const getReferenceSequenceReportPdf = async (caseId, startDate, endDate, accountCardId = null, sortCodeId = null, token) => {
    const response = await fetch(`${API_URL}/ReferenceSequenceReportPdf`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate,
            AccountCardCode: accountCardId,
            SortCodeId: sortCodeId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    return await response.blob();
};

const getReferenceSequenceReportExcel = async (caseId, startDate, endDate, accountCardId = null, sortCodeId = null, token) => {
    const response = await fetch(`${API_URL}/ReferenceSequenceReportExcel`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate,
            AccountCardCode: accountCardId,
            SortCodeId: sortCodeId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    return await response.blob();
};

const getSupplierWithholdingTaxSummary = async (caseId, startDate, endDate, accountantId, token, showMode = false, showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
    const response = await fetch(`${API_URL}/SupplierWithholdingTaxSummaryMonthly`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance,
            SupplierNameFilter: supplierNameFilter,
            UseCreditAccount: useCreditAccount
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        // Return HTML content for display
        return await response.text();
    } else {
        // Download PDF
        const blob = await response.blob();

        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ניכוי-במקור-תקופתי-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

const getSupplierWithholdingTaxSummaryYearly = async (caseId, startDate, accountantId, token, showMode = false, showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
    const response = await fetch(`${API_URL}/SupplierWithholdingTaxSummaryYearly`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance,
            SupplierNameFilter: supplierNameFilter,
            UseCreditAccount: useCreditAccount
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        // Return HTML content for display
        return await response.text();
    } else {
        // Download PDF
        const blob = await response.blob();

        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ניכוי-במקור-שנתי-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

const getSupplierWithholdingTaxSummaryMonthlyPeriod = async (caseId, startDate, endDate, accountantId, token, showMode = false, showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
    const response = await fetch(`${API_URL}/SupplierWithholdingTaxSummaryMonthlyPeriod`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance,
            SupplierNameFilter: supplierNameFilter,
            UseCreditAccount: useCreditAccount
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        // Return HTML content for display
        return await response.text();
    } else {
        // Download PDF
        const blob = await response.blob();

        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ניכוי-במקור-תקופתי-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

const getSupplierWithholdingTaxCertificate = async (caseId, startDate, accountantId, cardId = null, token, showMode = false, showZeroBalance = false, useCreditAccount = false) => {
    const response = await fetch(`${API_URL}/SupplierWithholdingTaxCertificate`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            CardId: cardId,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance,
            UseCreditAccount: useCreditAccount
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        // Return HTML content for display
        return await response.text();
    } else {
        // Download files
        const contentType = response.headers.get("Content-Type");

        if (contentType === "application/zip") {
            const blob = await response.blob();
            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', `ניכוי-במקור-אישור-${caseId}.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
        } else if (contentType === "application/pdf") {
            const blob = await response.blob();
            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', `ניכוי-במקור-אישור-${caseId}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
        }
    }
};

// ============ VAT Endpoints ============

// 1) Create a new VAT
const createReportedVat = async (vatData, token) => {
    const response = await fetch(`${REPORTS_API}/CreateVat`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(vatData),
    });
    return response;
};

// 2) Update an existing VAT
const updateReportedVat = async (id, vatData, token) => {
    const response = await fetch(`${REPORTS_API}/UpdateVat/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(vatData),
    });
    return response;
};

const deleteReportedVatByPeriod = async (vatData, token) => {
    const response = await fetch(`${REPORTS_API}/DeleteVatByPeriod`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify(vatData),
    });
    return response;
};

// 3) Send the VAT to the Tax Authority
const sendVatReporting = async (sendVatDto, token) => {
    // POST /ReportedTaxes/SendVatReporting
    const response = await fetch(`${REPORTS_API}/SendVatReporting`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(sendVatDto),
    });
    return response;
};

// ============ Advances/Withholding Endpoints ============

// 4) Create a new Advance
const createReportedAdvance = async (advanceData, token) => {
    const response = await fetch(`${REPORTS_API}/CreateAdvance`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(advanceData),
    });
    return response;
};

// 5) Update an existing Advance
const updateReportedAdvance = async (id, advanceData, token) => {
    const response = await fetch(`${REPORTS_API}/UpdateAdvance/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(advanceData),
    });
    return response;
};

// 6) Send an Advance to the Tax Authority
const sendAdvancesReport = async (sendAdvDto, token) => {
    const response = await fetch(`${REPORTS_API}/SendAdvancesReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(sendAdvDto),
    });
    return response;
};

const getVatByDateRange = async (dto, token) => {
    // dto = { CaseId, StartDate, EndDate, IsRange }
    // POST /api/ReportedTaxes/GetVatByDateRange
    const response = await fetch(`${REPORTS_API}/GetVatByDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto),
    });
    return response; // you'll parse .json() in your React code
};

/**
 * Virtual income net (and VAT) from code-1 JEs only, for VAT report modal.
 * POST /api/Clients/VatReportCode1Adjustments
 * @returns { Promise<{ incomeNetCode1: number, vatCode1: number }> }
 */
const getVatReportCode1Adjustments = async (caseId, startDate, endDate, token) => {
    const response = await fetch(`${CLIENTS_API}/VatReportCode1Adjustments`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate
        }),
    });
    if (!response.ok) {
        const err = await response.text();
        throw new Error(err || 'Failed to get code-1 adjustments');
    }
    const data = await response.json();
    return {
        incomeNetCode1: data.IncomeNetCode1 ?? data.incomeNetCode1 ?? 0,
        vatCode1: data.VatCode1 ?? data.vatCode1 ?? 0
    };
};

const getAdvanceByDateRange = async (dto, token) => {
    // POST /api/ReportedTaxes/GetAdvanceByDateRange
    const response = await fetch(`${REPORTS_API}/GetAdvanceByDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto),
    });
    return response;
};


// Checks if a VAT period already exists
// by posting to an endpoint like: POST /ReportedTaxes/IsVatPeriodReported
const isVatPeriodReported = async (caseId, startDate, endDate, token) => {
    // We'll assume you pass in actual date objects or ISO strings
    const dto = {
        CaseId: caseId,
        StartDate: startDate,
        EndDate: endDate
        // (if your controller requires an IsRange param, you can add it here)
    };

    const response = await fetch(`${REPORTS_API}/IsVatPeriodReported`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dto)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error checking if VAT period is reported: ${errorText}`);
    }

    // The response should be a boolean: true or false
    const result = await response.json();
    return result;
};

// Checks if an Advance period already exists
// by posting to an endpoint like: POST /ReportedTaxes/IsAdvancePeriodReported
const isAdvancePeriodReported = async (caseId, startDate, endDate, token) => {
    const dto = {
        CaseId: caseId,
        StartDate: startDate,
        EndDate: endDate
    };

    const response = await fetch(`${REPORTS_API}/IsAdvancePeriodReported`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dto)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error checking if Advance period is reported: ${errorText}`);
    }

    const result = await response.json();
    return result; // true or false
};

// Example optional: "createOrUpdateVat" that does a check first
const createOrUpdateVat = async (vatData, token) => {
    const { caseId, startDate, endDate } = vatData;

    // Call the isVatPeriodReported check
    const alreadyReported = await isVatPeriodReported(caseId, startDate, endDate, token);

    if (alreadyReported) {
        // If you want to do an update automatically, you'd need the ID of the existing record
        // But if your server auto-updates when it sees the same StartDate/EndDate, 
        // you can just call createReportedVat or do something else:
        console.log("VAT period is already reported, calling create anyway to let server handle it...");
    }

    return createReportedVat(vatData, token);
};

// Similarly, createOrUpdateAdvance...
const createOrUpdateAdvance = async (advanceData, token) => {
    const { caseId, startDate, endDate } = advanceData;

    const alreadyReported = await isAdvancePeriodReported(caseId, startDate, endDate, token);

    if (alreadyReported) {
        console.log("Advance period is already reported, calling create anyway...");
    }

    return createReportedAdvance(advanceData, token);
};


const deleteReportedAdvanceByPeriod = async (advanceData, token) => {
    const response = await fetch(`${REPORTS_API}/DeleteAdvanceByPeriod`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify(advanceData),
    });
    return response;
};

const isVatPeriodReportedForAccountant = async (accountantId, date, token) => {
    if (!date) {
        return {};
    }
    const response = await fetch(`${REPORTS_API}/IsVatPeriodReportedForAccountant`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ accountantId, date })
    });

    if (!response.ok) {
        throw new Error('Failed to fetch VAT period data');
    }

    const data = await response.json();
    // data = { results: { "CASEID1": "reported"/"notReported"/"notReportedperiod", ... } }
    return data;
}

const isAdvancePeriodReportedForAccountant = async (accountantId, date, token) => {
    if (!date) {
        return {};
    }
    const response = await fetch(`${REPORTS_API}/IsAdvancePeriodReportedForAccountant`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ accountantId, date })
    });

    if (!response.ok) {
        throw new Error('Failed to fetch Advance period data');
    }

    const data = await response.json();
    return data;
}


const calculateTax = async (caseId, accountantId, startDate, endDate) => {
    try {
        const token = await AuthService.getCurrentToken();

        // Format dates as YYYY-MM-DD if not already
        const formattedStart = typeof startDate === 'string' ? startDate : startDate.format('YYYY-MM-DD');
        const formattedEnd = typeof endDate === 'string' ? endDate : endDate.format('YYYY-MM-DD');

        const response = await fetch(`${API_URL}/calculateTax`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                caseId,
                accountantId,
                startDate: formattedStart,
                endDate: formattedEnd
            })
        });

        if (!response.ok) {
            // Try to read error message from response, if any
            let errMsg = 'Failed to fetch Advance period data';
            try {
                const errorData = await response.json();
                if (errorData?.message) errMsg = errorData.message;
            } catch (e) { /* ignore */ }
            throw new Error(errMsg);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // You may want to log or display error somewhere else too
        throw new Error(error.message || 'Network error');
    }
};




const GetTrialBalanceDetails = async (caseId, accountantId, startDate, endDate, isYearly, token, onlyProcessed = false, isProfitAndLoss = false, trialBalanceFilter = null, filterByDocumentDate = false, currencyFilter = null, includeForeignCurrency = false) => {
    try {
        const body = { caseId, accountantId, startDate, endDate, isYearly, onlyProcessed, isProfitAndLoss, filterByDocumentDate };
        // Foreign-currency columns: a specific currency, or mixed across all currencies.
        if (currencyFilter !== null && currencyFilter !== undefined) {
            body.currencyFilter = currencyFilter;
        }
        if (includeForeignCurrency) {
            body.includeForeignCurrency = true;
        }
        if (trialBalanceFilter && trialBalanceFilter.trialBalanceType === 'Projects') {
            body.trialBalanceType = 'Projects';
            if (trialBalanceFilter.fromSegmentationId) {
                body.fromSegmentationId = trialBalanceFilter.fromSegmentationId;
            }
            if (trialBalanceFilter.toSegmentationId) {
                body.toSegmentationId = trialBalanceFilter.toSegmentationId;
            }
        }
        const response = await fetch(`${AccountCards_API_URL}/trialBalanceDetails`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const GetPalCodesDetails = async (caseId, accountantId, startDate, endDate, isYearly, token, onlyProcessed = false, isProfitAndLoss = false, filterByDocumentDate = false) => {
    try {
        const response = await fetch(`${AccountCards_API_URL}/palcodesDetails`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, startDate, endDate, isYearly, onlyProcessed, isProfitAndLoss, filterByDocumentDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const getYearlyVatReport = async (caseId, date, token) => {
    const response = await fetch(`${REPORTS_API}/GenerateYearlyVatReport`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            Date: date
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error generating yearly VAT report: ${errorText}`);
    }

    const blob = await response.blob();

    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `דוח-מע״מ-שנתי-${caseId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
};

/**
 * Same computed-vs-reported comparison as GenerateYearlyVatReport, but as JSON so it can be
 * rendered on screen. Returns { caseId, year, reportingType, isBiMonthly, periods[], total* }.
 */
const getYearlyVatReportData = async (caseId, date, token) => {
    const response = await fetch(`${REPORTS_API}/GetYearlyVatReportData`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            Date: date
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Error loading yearly VAT report data (${response.status})`);
    }

    return response.json();
};

/** Returns the yearly comparative VAT report PDF as a blob, without triggering a download. */
const getYearlyVatReportBlob = async (caseId, date, token) => {
    const response = await fetch(`${REPORTS_API}/GenerateYearlyVatReport`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            Date: date
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Error generating yearly VAT report (${response.status})`);
    }

    return response.blob();
};

/**
 * Saves reported VAT for several periods at once.
 * periods: [{ startDate, endDate, VATTransactions, OtherVATTaxes, EquipmentVAT, NetVAT,
 *             IncomesNoVat, IncomesNoZeroVats, delete }]
 */
const createReportedVatBulk = async (caseId, periods, token) => {
    const response = await fetch(`${REPORTS_API}/CreateVatBulk`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId: caseId, Periods: periods })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Error saving reported VAT periods (${response.status})`);
    }

    return response.json();
};

/**
 * Reads a Tax Authority VAT summary report ("סיכומי דיווח") and returns the reported values
 * aligned to the client's monthly / bi-monthly period grid.
 */
const parseVatReportDocument = async (caseId, file, token, year = null) => {
    const formData = new FormData();
    formData.append('CaseId', caseId);
    formData.append('Document', file);
    if (year) {
        formData.append('Year', year);
    }

    const response = await fetch(`${REPORTS_API}/ParseVatReportDocument`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Error reading VAT report file (${response.status})`);
    }

    return response.json();
};

const getYearlyAdvanceReport = async (caseId, accountantId, date, token, partnerId = null) => {
    const response = await fetch(`${REPORTS_API}/GenerateYearlyAdvanceReport`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            Date: date,
            PartnerId: partnerId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error generating yearly advance report: ${errorText}`);
    }

    const blob = await response.blob();

    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `דוח-מקדמות-שנתי-${caseId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
};

const getAccumulatedDifferenceInAdvance = async (caseId, accountantId, date, token, partnerId = null) => {
    const response = await fetch(`${REPORTS_API}/GetAccumulatedDifferenceInAdvance`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            Date: date,
            PartnerId: partnerId
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error retrieving accumulated advance difference: ${errorText}`);
    }

    const data = await response.json();
    return data;
};

const getAccumulatedDifferenceInVat = async (caseId, date, token) => {
    const response = await fetch(`${REPORTS_API}/GetAccumulatedDifferenceInVat`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            Date: date
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error retrieving accumulated VAT difference: ${errorText}`);
    }

    const data = await response.json();
    return data;
};

// Always include every filter field so the backend validation requirements are satisfied.
const buildJournalDocumentationFilters = (filters = {}) => ({
    // 'reportingmonth' | 'registrationmonth' | 'document' — see JournalDocumentationDateTypes
    DateType: filters.dateType || 'reportingmonth',
    DebitAccountIds: filters.debitAccountIds || [],
    CreditAccountIds: filters.creditAccountIds || [],
    ReferenceFrom: filters.referenceFrom || '',
    ReferenceTo: filters.referenceTo || '',
    SortCodeIds: filters.sortCodeIds || [],
    UploadDateFrom: filters.uploadDateFrom || null,
    UploadDateTo: filters.uploadDateTo || null,
    ReportingMonthFrom: filters.reportingMonthFrom || null,
    ReportingMonthTo: filters.reportingMonthTo || null,
    ConfirmationNumber: filters.confirmationNumber || '',
    UploadNumberFrom: filters.uploadNumberFrom ?? null,
    UploadNumberTo: filters.uploadNumberTo ?? null,
    AccountCaseId: filters.accountCaseId || '',
    DescriptionContains: filters.descriptionContains || ''
});

const getJournalEntryDocumentation = async (caseId, startDate, endDate, documentType, token, sortBy = 'uploadNumber', sortDirection = 'asc', includeDescription = true, documentIds = null, filters = {}) => {
    const requestBody = {
        CaseId: caseId,
        StartDate: startDate,
        EndDate: endDate,
        DocumentTypes: [documentType],
        SortBy: sortBy,
        SortDirection: sortDirection,
        IncludeDescription: includeDescription,
        ...(documentIds && documentIds.length > 0 && { DocumentIds: documentIds }),
        ...buildJournalDocumentationFilters(filters)
    };

    const response = await fetch(`${API_URL}/JournalEntryDocumentation`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(`Error generating Journal Entry Documentation: ${errorText}`);
    }

    return await response.blob();
};

const getJournalEntryDocumentationData = async (caseId, startDate, endDate, documentTypes, token, sortBy = 'uploadNumber', sortDirection = 'asc') => {
    const response = await fetch(`${API_URL}/JournalEntryDocumentationData`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            CaseId: caseId,
            StartDate: startDate,
            EndDate: endDate,
            DocumentTypes: documentTypes,
            SortBy: sortBy,
            SortDirection: sortDirection
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error fetching documentation data: ${errorText}`);
    }

    return response.json();
};

const getJournalEntryDocumentationCombinedPdf = async (caseId, startDate, endDate, documentTypes, token, sortBy = 'uploadNumber', sortDirection = 'asc', includeDescription = true, documentIds = null, filters = {}) => {
    const requestBody = {
        CaseId: caseId,
        StartDate: startDate,
        EndDate: endDate,
        DocumentTypes: documentTypes,
        SortBy: sortBy,
        SortDirection: sortDirection,
        IncludeDescription: includeDescription,
        ...(documentIds && documentIds.length > 0 && { DocumentIds: documentIds }),
        ...buildJournalDocumentationFilters(filters)
    };

    const response = await fetch(`${API_URL}/JournalEntryDocumentationCombined`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error generating combined PDF: ${errorText}`);
    }

    return await response.blob();
};

const getJournalEntryDocumentationExcel = async (caseId, startDate, endDate, documentTypes, token, sortBy = 'uploadNumber', sortDirection = 'asc', includeDescription = true, documentIds = null, filters = {}) => {
    const requestBody = {
        CaseId: caseId,
        StartDate: startDate,
        EndDate: endDate,
        DocumentTypes: documentTypes,
        SortBy: sortBy,
        SortDirection: sortDirection,
        IncludeDescription: includeDescription,
        ...(documentIds && documentIds.length > 0 && { DocumentIds: documentIds }),
        ...buildJournalDocumentationFilters(filters)
    };

    const response = await fetch(`${API_URL}/JournalEntryDocumentationExcel`, {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
        throw new Error(await response.text());
    }

    return await response.blob();
};

const download856Combined = async (requestBody, token, t) => {
    const response = await fetch(`${API_URL}/856CombinedDownload`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
        const msg = response.message();
        if (msg === 'Client has no deduction case') {
            toast.error('ClientHasNoDeductionCase');
        } else {
            throw new Error(msg || t('ErrorDownloadingCombinedFile'));
        }
    }

    // Get the zip as a blob
    const blob = await response.blob();
    return blob;
};


const WithholdingTaxReport = async (caseId, accountantId, Date, EndDate, token, partnerId = null, onlyProcessed = true) => {

    const requestBody = {
        CaseId: caseId,
        AccountantId: accountantId,
        Date: Date,
        EndDate: EndDate,
        OnlyProcessed: !!onlyProcessed
    };

    // Add partnerId only if it's provided (not null, not undefined, not empty string)
    if (partnerId !== null && partnerId !== undefined && partnerId !== '') {
        requestBody.PartnerId = partnerId;
        console.log('Sending PartnerId in request:', partnerId);
    } else {
        console.log('No PartnerId provided, sending request without partner');
    }

    console.log('WithholdingTaxReport request body:', requestBody);

    const response = await fetch(`${API_URL}/WithholdingTaxReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the file content from the response
    const fileContent = await response.blob();

    // Create a URL for the file
    const fileUrl = window.URL.createObjectURL(fileContent);

    // Create a temporary link and trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'WithholdingTaxReport.pdf'); // Set the correct file name here
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

};

const vatTransactionHtml = async (dto, token) => {
    const response = await fetch(`${API_URL}/VatTransactionDocumentationHtml`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("VatTransactionDocumentationHtml Error:", errorText);
        throw new Error(`Failed to fetch VAT HTML: ${errorText}`);
    }

    return response; // Expects { success, message, data (html string) }
};


const vatTransactionPdf = async (dto, token) => {
    const response = await fetch(`${API_URL}/VatTransactionDocumentation`, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("VatTransactionDocumentation Error:", errorText);
        throw new Error(`Failed to fetch VAT PDF: ${errorText}`);
    }

    const blob = await response.blob();
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `VatTransactionDocumentation-${dto.caseId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
};

/**
 * Generate PDF from HTML using Reports API (returns blob directly)
 */
const generatePdfFromHtml = async (html, caseId, token, options = {}) => {
    const response = await fetch(`${API_URL}/GeneratePdfFromHtml`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            Html: html,
            CaseId: caseId,
            FileName: options.fileName,
            BackgroundColor: options.backgroundColor ?? '#ffffff',
            WritingColor: options.writingColor ?? 'black',
            IsNeedFooter: options.isNeedFooter ?? false,
            IncludePageNumbers: options.includePageNumbers ?? false,
            Landscape: options.landscape ?? false,
            Margins: options.margins ?? null
        })
    });

    if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText || 'Failed to generate PDF');
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = options.fileName;
    if (!fileName && contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) fileName = match[1].replace(/['"]/g, '');
    }
    return { blob, fileName };
};

/* place near the other helpers */
const convertHtmlToPdf = async (caseId, html, token) => {
    const response = await fetch(
        `${API_BASE}/DocumentGenerators/GeneratePdfFromHtml`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ CaseId: caseId, Html: html })
        }
    );

    if (!response.ok) {
        throw new Error(await response.text());
    }

    const { data } = await response.json();      // { fileName, pdfBase64 }
    const base64 = (data.pdfBase64 || data.PdfBase64 || '').replace(/\s+/g, '');

    /* turn the data‑URL into a real Blob without using atob */
    const blob = await (await fetch(`data:application/pdf;base64,${base64}`)).blob();

    return { fileName: data.fileName || data.FileName, blob };
};


// Client Withholding Tax Methods
const getClientWithholdingTaxSummary = async (caseId, startDate, endDate, accountantId, token, showMode = false, showZeroBalance = true) => {
    const response = await fetch(`${API_URL}/ClientWithholdingTaxSummaryMonthly`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        return await response.text();
    } else {
        const blob = await response.blob();
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ClientWithholdingTaxReport-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

const getClientWithholdingTaxSummaryYearly = async (caseId, startDate, accountantId, token, showMode = false, showZeroBalance = true, showReportingColumns = true) => {
    const response = await fetch(`${API_URL}/ClientWithholdingTaxSummaryYearly`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance,
            ShowReportingColumns: showReportingColumns
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        return await response.text();
    } else {
        const blob = await response.blob();
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ClientWithholdingTaxReport-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

const getClientWithholdingTaxSummaryMonthlyPeriod = async (caseId, startDate, endDate, accountantId, token, showMode = false, showZeroBalance = true) => {
    const response = await fetch(`${API_URL}/ClientWithholdingTaxSummaryMonthlyPeriod`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            ShowMode: showMode,
            ShowZeroBalance: showZeroBalance
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    if (showMode) {
        return await response.text();
    } else {
        const blob = await response.blob();
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `ClientWithholdingTaxReport-${caseId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    }
};

// Unified Excel Download Method for Client Withholding Tax Reports
const getClientWithholdingTaxSummaryExcel = async (caseId, startDate, endDate, accountantId, token, reportType, showZeroBalance = true) => {
    const response = await fetch(`${API_URL}/ClientWithholdingTaxSummaryExcel`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            ReportType: reportType, // "yearly", "monthly", or "monthlyperiod"
            ShowZeroBalance: showZeroBalance
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    const blob = await response.blob();
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    
    // Extract filename from Content-Disposition header if available
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = `ClientWithholdingTaxReport-${caseId}.xlsx`;
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
    }
    
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
};

// Save reporting withholding tax summary per account
const saveReportingWithholdingTaxSummaryPerAccount = async (requestData) => {
    const token = await getCurrentToken();
    const response = await fetch(`${API_URL}/SaveReportingWithholdingTaxSummaryPerAccount`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(requestData)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    return await response.json();
};

const getSupplierNamesForWithholdingTax = async (caseId, token) => {
    const response = await fetch(`${API_URL}/GetSupplierNamesForWithholdingTax/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    const result = await response.json();
    return result.data || [];
};

const getUnpaidSupplierTransactions = async ({
    caseId,
    accountantId,
    startDate,
    endDate,
    useCreditAccount = true,
    page = 1,
    pageSize = 25,
    supplierCardId = null,
    token,
    signal = null,
}) => {
    const response = await fetch(`${API_URL}/UnpaidSupplierTransactions`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        signal,
        body: JSON.stringify({
            CaseId: caseId,
            AccountantId: accountantId,
            StartDate: startDate,
            EndDate: endDate,
            UseCreditAccount: useCreditAccount,
            Page: page,
            PageSize: pageSize,
            SupplierCardId: supplierCardId || null
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    return await response.json();
};

const bulkCreatePaymentsFromSources = async (request, token) => {
    const response = await fetch(`${API_BASE}/PaymentAcceptances/BulkCreateFromSourceDocuments`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    return await response.json();
};

const getClientNamesForWithholdingTax = async (caseId, token) => {
    const response = await fetch(`${API_URL}/GetClientNamesForWithholdingTax/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error(errorText);
        throw new Error(errorText);
    }

    const result = await response.json();
    return result.data || [];
};

const ReportsService = {
    getReferenceSequenceReport,
    getReferenceSequenceReportHtml,
    getReferenceSequenceReportPdf,
    getReferenceSequenceReportExcel,
    getSupplierWithholdingTaxSummary,
    getSupplierWithholdingTaxSummaryYearly,
    getSupplierWithholdingTaxSummaryMonthlyPeriod,
    getSupplierWithholdingTaxCertificate,
    createReportedVat,
    updateReportedVat,
    sendVatReporting,
    createReportedAdvance,
    updateReportedAdvance,
    sendAdvancesReport,
    getVatByDateRange,
    getVatReportCode1Adjustments,
    getAdvanceByDateRange,
    isVatPeriodReported,
    isAdvancePeriodReported,
    createOrUpdateVat,
    createOrUpdateAdvance,
    deleteReportedVatByPeriod,
    deleteReportedAdvanceByPeriod,
    isVatPeriodReportedForAccountant,
    isAdvancePeriodReportedForAccountant,
    calculateTax,
    GetPalCodesDetails,
    GetTrialBalanceDetails,
    getYearlyVatReport,
    getYearlyVatReportData,
    getYearlyVatReportBlob,
    createReportedVatBulk,
    parseVatReportDocument,
    getYearlyAdvanceReport,
    getAccumulatedDifferenceInAdvance,
    getAccumulatedDifferenceInVat,
    getJournalEntryDocumentation,
    getJournalEntryDocumentationData,
    getJournalEntryDocumentationCombinedPdf,
    getJournalEntryDocumentationExcel,
    download856Combined,
    WithholdingTaxReport,
    vatTransactionHtml,
    vatTransactionPdf,
    convertHtmlToPdf,
    generatePdfFromHtml,
    // Client Withholding Tax Methods
    getClientWithholdingTaxSummary,
    getClientWithholdingTaxSummaryYearly,
    getClientWithholdingTaxSummaryMonthlyPeriod,
    
    // Client Withholding Tax Excel Method (Unified)
    getClientWithholdingTaxSummaryExcel,
    
    // Reporting Withholding Tax Methods
    saveReportingWithholdingTaxSummaryPerAccount,
    
    // Get Supplier/Client Names for Withholding Tax
    getSupplierNamesForWithholdingTax,
    getClientNamesForWithholdingTax,
    getUnpaidSupplierTransactions,
    bulkCreatePaymentsFromSources,
};


export default ReportsService;